import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import 'rxjs/add/operator/map';
import { Adconfirmation1Component } from './adconfirmation1/adconfirmation1.component';
import { Adsummary1Component } from './adsummary1/adsummary1.component';
import { Adsummary2Component } from './adsummary2/adsummary2.component';
import { Adsummary3Component } from './adsummary3/adsummary3.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AdsummaryComponent } from './classifiedad/adsummary/adsummary.component';
import { ClassifiedadComponent } from './classifiedad/classifiedad.component';
import { ComposeadComponent } from './classifiedad/composead/composead.component';
import { PaymentmethodComponent } from './classifiedad/paymentmethod/paymentmethod.component';
import { SelectdateComponent } from './classifiedad/selectdate/selectdate.component';
import { ClassifieddisplayComponent } from './classifieddisplay/classifieddisplay.component';
import { Dstep1Component } from './classifieddisplay/dstep1/dstep1.component';
import { Dstep2Component } from './classifieddisplay/dstep2/dstep2.component';
import { Dstep3Component } from './classifieddisplay/dstep3/dstep3.component';
import { Dstep4Component } from './classifieddisplay/dstep4/dstep4.component';
import { Datepicker1Component } from './datepicker1/datepicker1.component';
import { Datepicker2Component } from './datepicker2/datepicker2.component';
import { Datepicker3Component } from './datepicker3/datepicker3.component';
import { Dastep1Component } from './displayad/dastep1/dastep1.component';
import { Dastep2Component } from './displayad/dastep2/dastep2.component';
import { Dastep3Component } from './displayad/dastep3/dastep3.component';
import { Dastep4Component } from './displayad/dastep4/dastep4.component';
import { DisplayadComponent } from './displayad/displayad.component';
import { FooterComponent } from './footer/footer.component';
import { ForgotPasswordComponent } from './forgotpassword/forgotpassword.component';
import { Globals } from './Globals';
import { HeaderComponent } from './header/header.component';
import { HomeComponent } from './home/home.component';
import { NewPasswordComponent } from './new-password/new-password.component';
import { Paymentmethod1Component } from './paymentmethod1/paymentmethod1.component';
import { Paymentmethod2Component } from './paymentmethod2/paymentmethod2.component';
import { Paymentmethod3Component } from './paymentmethod3/paymentmethod3.component';
import { RegisterComponent } from './register/register.component';
import { SearchBookingComponent } from './search-booking/search-booking.component';
import { User } from './user';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { CookiePolicyComponent } from './cookie-policy/cookie-policy.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { ProfileComponent } from './profile/profile.component';
import { VieworderComponent } from './vieworder/vieworder.component';
import { MyorderComponent } from './myorder/myorder.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { OrderdetailsComponent } from './orderdetails/orderdetails.component';
import { CancelorderComponent } from './cancelorder/cancelorder.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SessionStorageService, StorageService } from './@core/common/storage.service';
import { AuthTokenInterceptor } from './@core/interceptor/auth-token.interceptor';





@NgModule({
  declarations: [
    AppComponent,
    NewPasswordComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    ClassifiedadComponent,
    ComposeadComponent,
    SelectdateComponent,
    AdsummaryComponent,
    ForgotPasswordComponent,
    PaymentmethodComponent,
    Datepicker1Component,
    Datepicker2Component,
    Datepicker3Component,
    Adsummary1Component,
    Adsummary2Component,
    Adsummary3Component,
    RegisterComponent,
    Paymentmethod1Component,
    Paymentmethod2Component,
    Paymentmethod3Component,
    Adconfirmation1Component,
    MyorderComponent,
    ClassifieddisplayComponent,
    Dstep1Component,
    Dstep2Component,
    Dstep3Component,
    Dstep4Component,
    DisplayadComponent,
    Dastep1Component,
    Dastep2Component,
    Dastep3Component,
    Dastep4Component,
    NewPasswordComponent,
    ForgotPasswordComponent,
    Adconfirmation1Component,
    SearchBookingComponent,
    ContactUsComponent,
    TermsConditionComponent,
    PrivacyPolicyComponent,
    CookiePolicyComponent,
    AboutUsComponent,
    ProfileComponent,
    VieworderComponent,
    VerifyEmailComponent,
    OrderdetailsComponent,
    CancelorderComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,BsDropdownModule.forRoot(),
    TooltipModule.forRoot(),
    ModalModule.forRoot(),
    // FormGroup,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule
  ],
  providers: [Globals, User, SessionStorageService, { provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptor, multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(public globals: Globals, public user: User) { }
}
